<div class="list-holder">
  <mat-card>
    <mat-card-content>
      <div class="top-holder">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Sök</mat-label>
          <input [formControl]="filterControl" matInput name="filterTrans">
        </mat-form-field>

        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Välj kontor</mat-label>
          <mat-select (selectionChange)="this.items.filter = $event.value">
            <mat-option value="">Samtliga kontor</mat-option>
            @for (office of offices(); track $index) {
              <mat-option [value]="office">{{ office }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <button (click)="loadList()" mat-mini-fab>
          <mat-icon>cached</mat-icon>
        </button>

      </div>
      @if (!showTable()) {
        <mat-progress-bar mode="indeterminate" style="margin: 20px 0;"/>
      } @else {
        <div>
          <table [dataSource]="items" mat-table matSort
                 matSortActive="timeStamp" matSortDirection="desc"
          >
            <caption style="display: none;">Lista över legitimeringar</caption>

            <ng-container matColumnDef="timeStamp">
              <th *matHeaderCellDef mat-header-cell mat-sort-header>Tidpunkt</th>
              <td
                *matCellDef="let element"
                [matTooltip]="convertDate(element.gdprRemove)"
                mat-cell matTooltipPosition="before">
                {{ element.timeStamp | date: 'yyyy-MM-dd HH:mm' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="personalNumber">
              <th *matHeaderCellDef mat-header-cell
                  mat-sort-header> Personnummer
              </th>
              <td *matCellDef="let element" mat-cell>
                {{ element.personalNumber }}

                @if (!element.personalNumber) {
                  Misslyckad
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th *matHeaderCellDef mat-header-cell
                  mat-sort-header> Namn
              </th>
              <td *matCellDef="let element" mat-cell>
                {{ element.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="age">
              <th *matHeaderCellDef mat-header-cell
                  mat-sort-header> Ålder
              </th>
              <td *matCellDef="let element" mat-cell>
                {{ element.age }}
              </td>
            </ng-container>

            <ng-container matColumnDef="coworkerName">
              <th *matHeaderCellDef mat-header-cell
                  mat-sort-header> Personal
              </th>
              <td *matCellDef="let element" mat-cell>
                {{ element.coworkerName }}
              </td>
            </ng-container>

            <ng-container matColumnDef="office">
              <th *matHeaderCellDef mat-header-cell
                  mat-sort-header> Kontor
              </th>
              <td *matCellDef="let element" mat-cell>
                {{ element.office }}
              </td>
            </ng-container>

            <ng-container matColumnDef="copy">
              <th *matHeaderCellDef mat-header-cell>
              </th>
              <td *matCellDef="let element" mat-cell>
                <button (click)="copyInfo(element)" matIconButton>
                  <mat-icon>content_copy</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="save">
              <th *matHeaderCellDef id="save" mat-header-cell></th>
              <td *matCellDef="let element"
                  class="pointer" mat-cell>
                <button (click)="saveInfo(element)" matIconButton>
                  <mat-icon>save</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr *matHeaderRowDef="columns()" mat-header-row></tr>
            <tr *matRowDef="let element; columns: columns()" mat-row></tr>

            <tr *matNoDataRow class="no-data">
              <td [attr.colspan]="columns().length" class="no-data">
                Inga legitimeringar hittades
              </td>
            </tr>
          </table>
          <mat-paginator [length]="100"
                         [pageSizeOptions]="[5, 10, 25, 100, 500, 1000]"
                         [pageSize]="10"
                         aria-label="Select page">
          </mat-paginator>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>